import Avatar from 'components/base/Avatar';
import { Card, Dropdown } from 'react-bootstrap';
import avatar from 'assets/img/team/72x72/57.webp';
import FeatherIcon from 'feather-icons-react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import { useLogout } from 'shared/api/auth';
import { logout } from 'shared/stored/Users/slice';
import { useTranslation } from 'react-i18next';

const ProfileDropdownMenu = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const logoutMutation = useLogout();
  const userProfile = useSelector((state: any) => state.user?.profile);

  const handleLogout = async () => {
    try {
      // Dispatch logout action to Redux
      dispatch(logout());
      await logoutMutation.mutateAsync();
    } catch (error) {
      console.error('Logout failed:', error);
      // Even if logout API fails, we should redirect to login
      window.location.href = '/sign-in';
    }
  };

  return (
    <Dropdown.Menu
      align="end"
      className={classNames(
        className,
        'navbar-top-dropdown-menu navbar-dropdown-caret py-0 dropdown-profile shadow border',
      )}
    >
      <Card className="position-relative border-0">
        <Card.Body className="p-0">
          <div className="d-flex flex-column align-items-center justify-content-center gap-2 pt-4 pb-3">
            <Avatar src={avatar} size="xl" />
            <h6 className="text-body-emphasis">{userProfile?.firstName} {userProfile?.lastName}</h6>
          </div>
          {/* <div className="mb-3 mx-3">
            <Form.Control
              type="text"
              placeholder="Update your status"
              size="sm"
            />
          </div>
          <div style={{ height: '10rem' }}>
            <div>
              <Nav className="nav flex-column mb-2 pb-1">
                {navItems.map(item => (
                  <Nav.Item key={item.label}>
                    <Nav.Link href="#!" className="px-3">
                      <FeatherIcon
                        icon={item.icon}
                        size={16}
                        className="me-2 text-body"
                      />
                      <span className="text-body-highlight">{item.label}</span>
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </div>
          </div> */}
        </Card.Body>
        <Card.Footer className="p-0 border-top border-translucent">
          {/* <Nav className="nav flex-column my-3">
            <Nav.Item>
              <Nav.Link href="#!" className="px-3">
                <FeatherIcon
                  icon="user-plus"
                  size={16}
                  className="me-2 text-body"
                />
                <span>Add another account</span>
              </Nav.Link>
            </Nav.Item>
          </Nav> */}
          {/* <hr /> */}
          <div className="px-3 mt-3">
            <button
              onClick={handleLogout}
              className="btn btn-phoenix-secondary d-flex flex-center w-100"
              disabled={logoutMutation.isPending}
            >
              <FeatherIcon icon="log-out" className="me-2" size={16} />
              {logoutMutation.isPending ? t('signing_out') : t('sign_out')}
            </button>
          </div>
          <div className="my-2 text-center fw-bold fs-10 text-body-quaternary">
            <Link className="text-body-quaternary me-1" to="#!">
              {t('privacy_policy')}
            </Link>
            •
            <Link className="text-body-quaternary mx-1" to="#!">
              {t('terms')}
            </Link>
            •
            <Link className="text-body-quaternary ms-1" to="#!">
              {t('cookies')}
            </Link>
          </div>
        </Card.Footer>
      </Card>
    </Dropdown.Menu>
  );
};

export default ProfileDropdownMenu;
